import { IMAGE_ASSETS } from "@/constants/images";

/** @deprecated import from `@/data/homepage-youtube` */
export {
  getYouTubeEmbedUrl,
  getYouTubeVideoId,
} from "./homepage-youtube";


export const WHY_AMITY_ONLINE_DATA = [
  {
    heading: "WASC Accreditation (USA)",
    subHeading:
      "Amity Online is India's only university accredited by the Western Association of Schools and Colleges  — a distinguished recognition of global academic excellence.",
    src: `https://amityonline.com/_s/WASC_new_logo_1_d7a81ca9c3.webp`,
    type: "PNG",
    style: '!w-[6rem]'
  },
  {
    heading: "WES Recognition",
    subHeading:
      "Degrees recognized by World Education Services (WES) Canada & USA, enabling smoother pathways for higher studies and global career mobility.",
    src: "https://static.amityonline.com/_s/Group_48099252_1_df96398b17_8a67bc8d63_b0fc08c271.webp",
    type: "PNG"
  },
  {
    heading: "QS Ranked Online MBA",
    subHeading: "Amity Online offers India's only Online MBA ranked by QS under Asia Pacific Top 10 - a global recognition for academic strength, learner outcomes, and digital innovation.",
    src: 'https://amityonline.com/_s/Group_48099254_1_46922cfc87_920634f33f.webp',
    type: "PNG"
  },
  {
    heading: "QAA (UK) Accreditation",
    subHeading: "Accredited by the UK's Quality Assurance Agency (QAA), assuring students of globally benchmarked academic quality.",
    src: "https://static.amityonline.com/_s/qaa_44482cac1e.webp",
    type: "PNG",
    style: '!w-[6rem]'
  },
  {
    heading: "Times Higher Education Employability Rankings",
    subHeading:
      "Amity University is ranked among the best globally for graduate employability and employer reputation by Times Higher Education.",
    src: 'https://static.amityonline.com/_s/Times_Higher_Education_logo_1_1_f1dd81080b.webp',
    type: "PNG",
    style: '!w-[7rem]'
  },
  {
    heading: "QS Reimagine Silver Award 2025",
    subHeading:
      "Awarded by QS for excellence in reimagining higher education through technology-enabled learning, student engagement, and scalable digital delivery.",
    src: 'https://static.amityonline.com/_s/QS_Reimagine_Silver_Award_Badge_0df3a2e01c.webp',
    type: "PNG"
  },
  {
    heading: "Pan-India Campus Access & Offline Events",
    subHeading:
      "Enjoy access to all Amity campuses for events like orientation, mid-year meetups, on-campus connect and convocation - blending digital convenience with real-world connection.",
    src: IMAGE_ASSETS.offlineExperiences,
    type: "IMG",
    width: 52,
    height: 52,
  },
  {
    heading: "Amigo: Learning On-the-Go",
    subHeading:
      "The Amigo app makes learning seamless and mobile — attend live classes, track progress, access materials, and more on your schedule.",
    src: IMAGE_ASSETS.lmsIcon,
    type: "IMG",
    width: 52,
    height: 52,
  },
  {
    heading: "Prof. Ami: Your AI-Powered Personal Tutor",
    subHeading:
      "Meet Prof. Ami — your always-on, AI mentor for instant doubt-solving, personalised learning tips, and smart academic support.",
    src: IMAGE_ASSETS.aiProfessor,
    type: "IMG",
    width: 52,
    height: 52,
  },
  {
    heading: "Industry Certifications for Better Employability",
    subHeading:
      "Gain an edge with in-demand certifications from top industry bodies and partners — integrated within your program to boost your skills and CV.",
    src: IMAGE_ASSETS.diverseLearningMediums,
    type: "IMG",
    width: 52,
    height: 52,
  },
  {
    heading: "Internship Opportunities",
    subHeading:
      "Access curated internships with leading companies through our corporate network, helping you gain real-world experience and stand out in the job market.",
    src: IMAGE_ASSETS.placementOpportunities,
    type: "IMG",
    width: 52,
    height: 45,
  },
  {
    heading: "AI-Powered Career Discovery Platform",
    subHeading:
      "From mock interviews and resume building to job search and easy-apply tools — our AI-powered platform ensures you’re career-ready from day one.",
    src: IMAGE_ASSETS.careerServices,
    type: "IMG",
    width: 52,
    height: 52,
  },
  {
    heading: "beSocial App for Campus Life",
    subHeading:
      "Your virtual student hub — the beSocial app lets you network, join clubs, attend events, and be part of a vibrant, online-first community.",
    src: 'https://amityonline.com/_s/besocial_1_1db313ae01.webp',
    srcset: "https://amityonline.com/_s/besocial_1_1db313ae01_1_5f740e0b43.webp",
    type: "PNG"
  },
];

export const PLACEMENT_DATA = [
  { src: IMAGE_ASSETS.placementGamified, title: "", desc: "Free AI Certification", bgColor: "#dce5f5", width: 40, height: 40 },
  { src: IMAGE_ASSETS.placementLMaterial, title: "", desc: "Interactive Learning Material with AI-Powered Features", bgColor: "#fffae6", width: 40, height: 40 },
  { src: IMAGE_ASSETS.placementLDesign, title: "", desc: "Inclusive & Flexible Learning Design", bgColor: "#ffebef", width: 40, height: 40 },
  { src: IMAGE_ASSETS.placementOfflineExperience, title: "", desc: "Offline Experiences ", bgColor: "#f0faf4", width: 40, height: 40 },
]

export const REVIEWS_VIDEO_DATA = [
  {
    name: "Ruchir",
    title: "BBA, Student",
    image: "https://amityonline.com/_s/testimonial5_f1f18c7f4f.webp",
    video: "https://amityonline.com/_s/Ruchir_943cd604e9.mp4",
  },
  {
    name: "Priyanka Shreshtha",
    title: "BBA, Student",
    image: "https://amityonline.com/_s/testimonial_d704020b98_1_fd7301c47e.webp",
    video: "https://amityonline.com/_s/videoplayback_2_5de64578d2.mp4",
  },
  {
    name: "Abhik Ganguly",
    title: "MBA, Student",
    image: "https://amityonline.com/_s/testimonial6_7b5402bd51_1_a467674e57.webp",
    video: "https://amityonline.com/_s/Abhik_Ganguly_MBA_7a2039ef1b.mp4",
  },
  {
    name: "Ridhima Rai",
    title: "BBA, Student",
    image: "https://amityonline.com/_s/testimonial2_5d0dd6aca9.webp",
    video: "https://amityonline.com/_s/videoplayback_3_27f407a07d.mp4",
  },
  {
    name: "Tanya Luthra",
    title: "B.com (Hons.), Student",
    image: "https://amityonline.com/_s/testimonial1_ad369dded1.webp",
    video: "https://amityonline.com/_s/Tanya+Luthra.mp4",
  },
  {
    name: "Shalu Sharma",
    title: "MAJMC, Student",
    image: "https://amityonline.com/_s/testimonial4_82a832c9ce.webp",
    video: "https://amityonline.com/_s/Shalu+Sharma.mp4",
  },
  {
    name: "Anushka Pathak",
    title: "MBA, Student",
    image: "https://amityonline.com/_s/testimonial3_32edcb37a5.webp",
    video: "https://amityonline.com/_s/Anushka+Pathak.mp4",
  },
]

export const REVIEWS_VIDEO_DATA_REVAMP = [
  {
    name: "Sujata Iyer",
    title: "MAJMC, Class of 2025",
    image: "_s/sujata_75c5c924f3.webp",
    video: "https://youtube.com/shorts/v1I3gY80_I0?si=c-QIPzRFibpKxSHi"
  },
  {
    name: "Rehema A Issa",
    title: "BBA, Class of 2025",
    image: "_s/Rehema_8e3f33bd61.webp",
    video: "https://youtube.com/shorts/XCh8ylvWGHc?feature=share"
  },
  {
    name: "Shivangi Gupta",
    title: "MBA, Jan'25",
    image: "https://static.amityonline.com/_s/shivangi_gupta_ddb2154cc6.webp",
    video: "https://youtube.com/shorts/wdvvBVBKFv0?si=gyYIPdPZw3lmsWAY"
  },
  {
    name: "Ayushi Podder",
    title: "MBA, Jan'25",
    image: "https://static.amityonline.com/_s/ayushi_poddar_6ff69e918e.webp",
    video: "https://youtube.com/shorts/7k38R4nnpd0?si=MzLrIaRNUVDpwCca"
  },
  {
    name: "Aayush Kumar",
    title: "BCA+MCA, Jul'25",
    image: "https://static.amityonline.com/_s/ayush_kumar_ba95fcbcaf.webp",
    video: "https://youtube.com/shorts/HtUUjvU6_w8?si=XIFqkWafp-e6ULfX"
  },
  {
    name: "Dev Sharma",
    title: "BAJMC, Jul'25",
    image: "https://static.amityonline.com/_s/dev_sharma_38bef66cae.webp",
    video: "https://youtube.com/shorts/2VYgF6qsM88?si=ddK9eWP-QNTA9ZH_"
  },
];
export const REVIEWS_VIDEO_DATA_REVAMP_MBA = [
  {
    name: "Shivangi Gupta",
    title: "MBA, Jan'25",
    image: "https://amityonline.com/_s/shivangi_gupta_ddb2154cc6.webp",
    video: "https://youtube.com/shorts/wdvvBVBKFv0?si=gyYIPdPZw3lmsWAY",
    rating: 5,
  },
  {
    name: "Ayushi Podder",
    title: "MBA, Jan'25",
    image: "https://amityonline.com/_s/ayushi_poddar_6ff69e918e.webp",
    video: "https://youtube.com/shorts/7k38R4nnpd0?si=MzLrIaRNUVDpwCca",
    rating: 5,
  },
];

export const STUDENT_STORIES_DATA = [
  {
    rating: 5,
    sent_by: {
      avatar: "_s/priyanshu_mishra_95cf7b8300.webp",
      avatar_original: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/2dbf5662-6a3d-4386-a1f4-404b717e2491.png",
      name: "Priyanshu Mishra",
      title: "MBA, Jul'25"
    },
    text: "My name is Priyanshu mishra,I am a first year student at Amity University. I am truly grateful to the Career Services team at Amity University for their constant support and guidance in helping me secure my internship as an HR Intern with Inorg. The entire process was extremely smooth and well-structured, right from the initial communication to the final selection. The Career Services team not only provided timely updates but also guided me at every stage, ensuring that I was well-prepared and confident throughout the process. Their personalized approach, encouragement, and professional mentorship made the journey very comfortable and stress-free. I sincerely appreciate the efforts of the Career Services Department in creating such valuable opportunities for students and helping us step forward in building our careers. This internship is an important milestone for me, and I owe it to the continuous support and excellent guidance of Amity’s Career Services."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "_s/Prerna_6a34679724.webp",
      avatar_original: "",
      name: "Prerna Keshari",
      title: "BCA, Jul'24"
    },
    text: "As a working professional, I chose Amity Online for its flexibility and UGC-approved degrees. The well-designed programs, live and recorded lectures, e-books, and expert faculty make learning practical and convenient."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/e1761453-2ce0-4b18-89f3-706dcac8a74f.webp",
      avatar_original: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/2dbf5662-6a3d-4386-a1f4-404b717e2491.png",
      name: "Jatin Gupta",
      title: "MBA, July'25"
    },
    text: "Hello, first of all Jatin Gupta this side and I enrolled for online MBA in Amity University Online for the upcoming July 2025 batch, Though I just joined Amity Online but, I'm taking no time to appreciate the way they are offering this course. It's really amazing like I am running my own retail outlet and it is hard to attend all live lectures so they are also offering recording of their live lectures which is so great! Also, they don't only provide recordings for lectures only but also for their live events so that we don't miss out on anything. The onboarding experience was so smooth and you get email alerts for almost everything, from Chairman's message to LMS password setup and walkthrough videos everything is provided. I haven't faced any problem so far even though I was reluctant in the beginning as to how this will work but trust me it's so easy. Amity University Online also has mobile app for the LMS platform where you basically study and submit assignments and I found it very convenient, I can study while being in a metro, that's handy. They also have an app for the besocial platform which delivers campus vibes it's basically just like a social media/community platform of Amity University Online where you can connect with other students and also share posts and participate in contests. They also provide some campus immersion opportunity like orientation and convocation and I think they are doing a lot for students, still a lot to explore but I'm sure it's going to be great because first impression is the last impression."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/11a1e713-9ec0-46c6-ba31-64d3cd8aa150.webp",
      avatar_original: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/2dbf5662-6a3d-4386-a1f4-404b717e2491.png",
      name: "Mohd. Aasif Ansari",
      title: "MBA - HRM Jan'25"
    },
    text: "My name is Mohd. Aasif Ansari, and I'm currently pursuing my MBA from Amity University Online, having completed my BBA in Marketing, what truly motivated me to choose Amity Online was its reputation for flexible, high-quality education backed by a globally recognized curriculum and strong student support, something that fits perfectly with my professional goals and entrepreneurial aspirations. My experience so far has been both enriching and empowering. The faculty members are highly knowledgeable, approachable, and genuinely invested in helping us grow. The course content is well-structured, industry-relevant, and easy to follow even for those managing work or other responsibilities alongside their studies. One of the standout skills I've gained is strategic thinking, particularly in marketing and business planning. Additionally, I've improved my communication, problem-solving, and digital collaboration skills, all crucial in today's fast-paced business environment. What I found most beneficial were the live sessions, recorded lectures, peer interaction on beSocial (Amity Online's very own student community platform), and the access to a digital library and career services. These features ensure that learning never stops, and helps bridge the gap between academics and real-world application. Without a doubt, I would recommend Amity University Online to anyone who wants to upskill while maintaining a flexible schedule. Whether you are a working professional, a fresh graduate, or someone looking to pivot careers, Amity Online provides the best tools and support you need to succeed."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://static.amityonline.com/_s/samendra_kumar_b3860115be.webp",
      avatar_original: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/2dbf5662-6a3d-4386-a1f4-404b717e2491.png",
      name: "Samrendra Kumar Yadav",
      title: "MBA, Jan'25"
    },
    text: "I chose Amity Online because of its reputation for academic excellence, industry-aligned curriculum, and the flexibility it offers to balance studies with other responsibilities. The platform's use of digital tools, experienced faculty, and global recognition made it an ideal choice for my educational journey. My experience with the Amity Online Learning Management System (LMS) has been smooth and user-friendly. The platform is well-organized, making it easy to access lectures, assignments, and study materials anytime. The faculty members are knowledgeable and approachable. Their recorded lectures, timely responses, and engagement during live sessions have been very helpful in understanding key concepts. The overall course structure is well-designed, with a balanced mix of theory, practical applications, and assessments. It allows me to learn at my own pace while staying on track with deadlines. Amity Online has positively impacted both my personal and professional life. Personally, it has helped me develop better time management, self-discipline, and digital learning skills. Professionally, the industry-relevant curriculum and skill-based learning have enhanced my knowledge and confidence. It has opened up new career opportunities, improved my problem-solving abilities, and strengthened my resume with globally recognized credentials. If you’re thinking about joining Amity University Online, I would definitely encourage you to go for it."
  },
];
export const STUDENT_STORIES_DATA_BRAND = [
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_5598dbc9dd.webp",
      name: "Jia Shah",
    },
    text: "My global learning journey taught me resilience, adaptability, and purpose. Every challenge became a step towards a stronger comeback."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_9_582b20b4d0.webp",
      name: "Satheesh Nair",
    },
    text: "With 18+ years in IT leadership, Amity Online helped me upskill flexibly with practical learning, great faculty, and real career impact."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_1_57a1f36e85.webp",
      name: "Khushal Walia",
    },
    text: "While pursuing my MBA, I launched my startup, Welexo, to make global trade intelligence accessible for businesses of all sizes."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_2_5b7b915a40.webp",
      name: "Ruchir Verma",
    },
    text: "Being a working professional, my three-year journey with Amity Online has been smooth, flexible, and truly enjoyable. Excited to continue learning further."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_3_87d7ecda71.webp",
      name: "Rehema A Issa",
    },
    text: "As a Strategic Planning Manager, I value Amity Online’s flexibility, supportive faculty, and excellent student support. Truly worth the investment."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_4_b2716ca2b2.webp",
      name: "Priyanshu Mishra",
    },
    text: "Grateful to Amity Online Career Services for their constant support, guidance, and mentorship in helping secure my HR internship at Inorg."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_5_0cfbfb64f0.webp",
      name: "Thokchom Lolet Singh",
    },
    text: "An Amity Online BBA alumnus turned his degree into a global career opportunity, securing an international placement in Sofia, Bulgaria, Europe."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_7_3453264470.webp",
      name: "Nupur Mehrotra",
    },
    text: "I never stopped learning, even while raising a family — balancing responsibilities and ambition without putting my dreams on hold."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_6_59d3f022fb.webp",
      name: "Meghna Kharera",
    },
    text: "I upskilled myself, embraced new opportunities, and confidently switched career paths to build a better future and move forward with purpose."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amityonline.com/_s/Container_8_604eccfff6.webp",
      name: "Nicole Liza Fernandes",
    },
    text: "My pincode never defined my potential. Amity Online gave me the flexibility and confidence to dream bigger from Goa to global opportunities."
  },
];
export const STUDENT_STORIES_DATA_MBA = [
  {
    rating: 5,
    sent_by: {
      avatar: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/e1761453-2ce0-4b18-89f3-706dcac8a74f.webp",
      avatar_original: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/2dbf5662-6a3d-4386-a1f4-404b717e2491.png",
      name: "Jatin Gupta",
      title: "MBA, July'25"
    },
    text: "Hello, first of all Jatin Gupta this side and I enrolled for online MBA in Amity University Online for the upcoming July 2025 batch, Though I just joined Amity Online but, I'm taking no time to appreciate the way they are offering this course. It's really amazing like I am running my own retail outlet and it is hard to attend all live lectures so they are also offering recording of their live lectures which is so great! Also, they don't only provide recordings for lectures only but also for their live events so that we don't miss out on anything. The onboarding experience was so smooth and you get email alerts for almost everything, from Chairman's message to LMS password setup and walkthrough videos everything is provided. I haven't faced any problem so far even though I was reluctant in the beginning as to how this will work but trust me it's so easy. Amity University Online also has mobile app for the LMS platform where you basically study and submit assignments and I found it very convenient, I can study while being in a metro, that's handy. They also have an app for the besocial platform which delivers campus vibes it's basically just like a social media/community platform of Amity University Online where you can connect with other students and also share posts and participate in contests. They also provide some campus immersion opportunity like orientation and convocation and I think they are doing a lot for students, still a lot to explore but I'm sure it's going to be great because first impression is the last impression."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/11a1e713-9ec0-46c6-ba31-64d3cd8aa150.webp",
      avatar_original: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/2dbf5662-6a3d-4386-a1f4-404b717e2491.png",
      name: "Mohd. Aasif Ansari",
      title: "MBA - HRM Jan'25"
    },
    text: "My name is Mohd. Aasif Ansari, and I'm currently pursuing my MBA from Amity University Online, having completed my BBA in Marketing, what truly motivated me to choose Amity Online was its reputation for flexible, high-quality education backed by a globally recognized curriculum and strong student support, something that fits perfectly with my professional goals and entrepreneurial aspirations. My experience so far has been both enriching and empowering. The faculty members are highly knowledgeable, approachable, and genuinely invested in helping us grow. The course content is well-structured, industry-relevant, and easy to follow even for those managing work or other responsibilities alongside their studies. One of the standout skills I've gained is strategic thinking, particularly in marketing and business planning. Additionally, I've improved my communication, problem-solving, and digital collaboration skills, all crucial in today's fast-paced business environment. What I found most beneficial were the live sessions, recorded lectures, peer interaction on beSocial (Amity Online's very own student community platform), and the access to a digital library and career services. These features ensure that learning never stops, and helps bridge the gap between academics and real-world application. Without a doubt, I would recommend Amity University Online to anyone who wants to upskill while maintaining a flexible schedule. Whether you are a working professional, a fresh graduate, or someone looking to pivot careers, Amity Online provides the best tools and support you need to succeed."
  },
  {
    rating: 5,
    sent_by: {
      avatar: "https://static.amityonline.com/_s/priyanshu_mishra_95cf7b8300.webp",
      avatar_original: "https://amity-strapi-file-uploads.s3.ap-south-1.amazonaws.com/testimonial/2dbf5662-6a3d-4386-a1f4-404b717e2491.png",
      name: "Priyanshu Mishra",
      title: "MBA, Jul’25"
    },
    text: "My name is Priyanshu mishra,I am a first year student at Amity University. I am truly grateful to the Career Services team at Amity University for their constant support and guidance in helping me secure my internship as an HR Intern with Inorg. The entire process was extremely smooth and well-structured, right from the initial communication to the final selection. The Career Services team not only provided timely updates but also guided me at every stage, ensuring that I was well-prepared and confident throughout the process. Their personalized approach, encouragement, and professional mentorship made the journey very comfortable and stress-free. I sincerely appreciate the efforts of the Career Services Department in creating such valuable opportunities for students and helping us step forward in building our careers. This internship is an important milestone for me, and I owe it to the continuous support and excellent guidance of Amity’s Career Services."
  },
];



/** @deprecated Prefer `@/features/everything-answered` mapper. Kept for legacy imports. */
export { mapQuestionsMapping } from "@/features/everything-answered/mapper/everything-answered.mapper";
